export default el => {
	const header = el.closest('header');

	el.addEventListener('click', () => {
		el.classList.toggle('active');
		header.classList.toggle('active');
	})
};